import { ReactElement } from 'react';
import { tokens } from '../../theme';

type StepIndicatorProps = {
  currentStep: number;
  totalSteps: number;
};

export const StepIndicator = ({ currentStep, totalSteps }: StepIndicatorProps): ReactElement => {
  const steps = Array.from({ length: totalSteps }, (_, index) => index + 1);

  return (
    <div
      role="progressbar"
      aria-valuenow={currentStep}
      aria-valuemin={1}
      aria-valuemax={totalSteps}
      aria-label={`Etapa ${currentStep} de ${totalSteps}`}
      style={styles.container}
    >
      {steps.map((step) => (
        <span
          key={step}
          style={{
            ...styles.dot,
            width:
              step === currentStep
                ? tokens.dimensions.stepDotActiveWidth
                : tokens.dimensions.stepDotSize,
            backgroundColor:
              step <= currentStep
                ? tokens.colors.brand.green.dark50
                : tokens.colors.brand.green.light650,
          }}
        />
      ))}
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacing.tiny,
  },
  dot: {
    height: tokens.dimensions.stepDotSize,
    borderRadius: tokens.dimensions.stepDotSize / 2,
    flexShrink: 0,
  },
};
